import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Icon } from '@blueprintjs/core';
import type { HeroProps } from '../../types';
import './Hero.scss';

const Hero: React.FC<HeroProps> = ({
  title,
  subtitle,
  ctaText = 'Get Started',
  ctaLink = '/contact',
  backgroundClass = '',
}) => {
  return (
    <section className={`hero ${backgroundClass}`}>
      <div className="hero__container">
        <div className="hero__content">
          <h1 className="hero__title">{title}</h1>
          {subtitle && <p className="hero__subtitle">{subtitle}</p>}
          {ctaText && (
            <div className="hero__actions">
              <Link to={ctaLink}>
                <Button
                  intent="success"
                  large
                  rightIcon={<Icon icon="arrow-right" />}
                  className="hero__cta"
                >
                  {ctaText}
                </Button>
              </Link>
              <Link to="/living-benefits">
                <Button
                  large
                  outlined
                  className="hero__cta-secondary"
                >
                  Learn More
                </Button>
              </Link>
            </div>
          )}
        </div>
        <div className="hero__visual">
          <div className="hero__stats">
            <div className="hero__stat">
              <span className="hero__stat-number">70%</span>
              <span className="hero__stat-label">of Americans are underinsured</span>
            </div>
            <div className="hero__stat">
              <span className="hero__stat-number">66%</span>
              <span className="hero__stat-label">of bankruptcies are medical-related</span>
            </div>
            <div className="hero__stat">
              <span className="hero__stat-number">$0</span>
              <span className="hero__stat-label">extra cost for Living Benefits</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
